var map = {
	"./apryse-logo.svg": 34096,
	"./calibrate.svg": 29739,
	"./digital_signature_empty.svg": 21085,
	"./digital_signature_error.svg": 49532,
	"./digital_signature_valid.svg": 33708,
	"./digital_signature_warning.svg": 34274,
	"./function.svg": 42508,
	"./group-annotations-icon.svg": 99302,
	"./ic-accounting.svg": 85350,
	"./ic-align-bottom-ios.svg": 32788,
	"./ic-align-middle-ios.svg": 70298,
	"./ic-align-top-ios.svg": 83430,
	"./ic-alignment-bottom.svg": 65068,
	"./ic-alignment-center-horizontal.svg": 31351,
	"./ic-alignment-center-vertical.svg": 45125,
	"./ic-alignment-left.svg": 83734,
	"./ic-alignment-main.svg": 30766,
	"./ic-alignment-right.svg": 14133,
	"./ic-alignment-top.svg": 26518,
	"./ic-audio-redact.svg": 1569,
	"./ic-automatic.svg": 88730,
	"./ic-bookmark.svg": 91261,
	"./ic-border-main.svg": 43039,
	"./ic-calculator.svg": 47257,
	"./ic-calendar-time.svg": 99295,
	"./ic-calendar.svg": 56187,
	"./ic-calibrate.svg": 97880,
	"./ic-clock-hour.svg": 84284,
	"./ic-column-delete-shift-left.svg": 52932,
	"./ic-column-delete-shift-up.svg": 90668,
	"./ic-column-delete.svg": 54357,
	"./ic-column-insert-left.svg": 37527,
	"./ic-column-insert-right.svg": 58546,
	"./ic-column-insert-shift-down.svg": 10089,
	"./ic-column-insert-shift-right.svg": 33801,
	"./ic-column-insert.svg": 96323,
	"./ic-copy-color.svg": 49752,
	"./ic-currency.svg": 94768,
	"./ic-decrease-decimal.svg": 77395,
	"./ic-delete-page.svg": 6524,
	"./ic-delete.svg": 66464,
	"./ic-distribute-horizontal.svg": 73429,
	"./ic-distribute-vertical.svg": 50979,
	"./ic-dollar-circle-rounded.svg": 32168,
	"./ic-dollar-circle.svg": 9236,
	"./ic-edit-page.svg": 61431,
	"./ic-file-cad.svg": 69172,
	"./ic-file-doc.svg": 26874,
	"./ic-file-etc.svg": 41762,
	"./ic-file-img.svg": 77261,
	"./ic-file-pdf.svg": 24666,
	"./ic-file-ppt.svg": 67308,
	"./ic-file-xls.svg": 62583,
	"./ic-fill-and-sign.svg": 78568,
	"./ic-fill.svg": 29742,
	"./ic-folder-open.svg": 20890,
	"./ic-full-frame-video-and-audio-redact.svg": 86585,
	"./ic-full-frame-video-redact.svg": 51802,
	"./ic-hamburger-menu.svg": 13022,
	"./ic-increase-decimal.svg": 32675,
	"./ic-indent-decrease.svg": 10504,
	"./ic-indent-increase.svg": 30868,
	"./ic-insert text.svg": 22591,
	"./ic-layer.svg": 62572,
	"./ic-merge.svg": 53227,
	"./ic-number.svg": 30366,
	"./ic-paragraph.svg": 57597,
	"./ic-percent.svg": 85616,
	"./ic-replace text.svg": 63680,
	"./ic-row-delete.svg": 21397,
	"./ic-row-insert-bottom.svg": 56981,
	"./ic-row-insert-top.svg": 24989,
	"./ic-table.svg": 76095,
	"./ic-unmerge.svg": 11816,
	"./ic-wv3d-properties-panel-menu.svg": 75598,
	"./ic_annotation_area_black_24px.svg": 30421,
	"./ic_annotation_cloudy_rectangular_area_black_24px.svg": 73419,
	"./ic_annotation_ellipse_area_black.svg": 34525,
	"./ic_annotation_eraser_black_24px.svg": 93592,
	"./ic_annotation_rectangular_area_black_24px.svg": 73520,
	"./ic_annotation_signature_black_24px.svg": 63328,
	"./ic_annotation_strikeout_black_24px.svg": 30876,
	"./ic_annotation_underline_black_24px.svg": 6314,
	"./ic_bookmarks_black_24px.svg": 98495,
	"./ic_check_black_24px.svg": 50314,
	"./ic_chevron_down_black_24px.svg": 5680,
	"./ic_chevron_left_black_24px.svg": 66457,
	"./ic_chevron_right_black_24px.svg": 95976,
	"./ic_chevron_up_black_24px.svg": 10241,
	"./ic_close_black_24px.svg": 54814,
	"./ic_copy_black_24px.svg": 57997,
	"./ic_crop_black_24px.svg": 96706,
	"./ic_edit_page_24px.svg": 18832,
	"./ic_fileattachment_24px.svg": 13411,
	"./ic_layers_24px.svg": 54198,
	"./ic_pause_24px.svg": 48020,
	"./ic_play_24px.svg": 45370,
	"./ic_select_black_24px.svg": 23656,
	"./ic_snipping_black_24px.svg": 74548,
	"./ic_sound_24px.svg": 78505,
	"./ic_thumbnails_grid_black_24px.svg": 10552,
	"./icon-accessibility-mode.svg": 45048,
	"./icon-action-redo.svg": 14955,
	"./icon-action-undo.svg": 55125,
	"./icon-active-indicator.svg": 39698,
	"./icon-add-file.svg": 51828,
	"./icon-add-folder.svg": 5014,
	"./icon-alert.svg": 76690,
	"./icon-annotate-ribbon.svg": 34317,
	"./icon-annotation-select-multiple.svg": 9305,
	"./icon-annotation-status-accepted.svg": 39224,
	"./icon-annotation-status-cancelled.svg": 2996,
	"./icon-annotation-status-completed.svg": 81446,
	"./icon-annotation-status-marked.svg": 8339,
	"./icon-annotation-status-none.svg": 57185,
	"./icon-annotation-status-rejected.svg": 91933,
	"./icon-annotation-status-unmarked.svg": 84598,
	"./icon-arrow-back.svg": 61293,
	"./icon-arrow-down.svg": 68352,
	"./icon-arrow-left.svg": 41327,
	"./icon-arrow-right.svg": 97066,
	"./icon-arrow-to-bottom.svg": 9873,
	"./icon-arrow-to-middle.svg": 95087,
	"./icon-arrow-to-top.svg": 89801,
	"./icon-arrow-up.svg": 94355,
	"./icon-chat-bubble.svg": 13305,
	"./icon-chevron-down.svg": 89638,
	"./icon-chevron-left.svg": 72877,
	"./icon-chevron-right.svg": 70576,
	"./icon-chevron-up.svg": 13853,
	"./icon-close.svg": 97068,
	"./icon-comments-filter.svg": 29333,
	"./icon-compare-change.svg": 40246,
	"./icon-compare-file-open.svg": 63425,
	"./icon-content-edit.svg": 78708,
	"./icon-copy.svg": 54575,
	"./icon-copy2.svg": 53567,
	"./icon-cut.svg": 59448,
	"./icon-dark-mode-option.svg": 5906,
	"./icon-delete-line.svg": 88680,
	"./icon-detach-toolbar.svg": 96847,
	"./icon-double-chevron-down.svg": 19910,
	"./icon-download.svg": 19816,
	"./icon-drag-handle.svg": 9585,
	"./icon-edit-form-field.svg": 81048,
	"./icon-folder.svg": 22236,
	"./icon-form-field-button.svg": 70830,
	"./icon-form-field-checkbox.svg": 20885,
	"./icon-form-field-combobox.svg": 97607,
	"./icon-form-field-listbox.svg": 88145,
	"./icon-form-field-radiobutton.svg": 6423,
	"./icon-form-field-signature.svg": 83200,
	"./icon-form-field-text.svg": 54939,
	"./icon-header-chat-line.svg": 49897,
	"./icon-header-compare.svg": 33485,
	"./icon-header-file-picker-line.svg": 93736,
	"./icon-header-full-screen-exit.svg": 39793,
	"./icon-header-full-screen.svg": 18620,
	"./icon-header-page-manipulation-insert-above.svg": 69797,
	"./icon-header-page-manipulation-line.svg": 52100,
	"./icon-header-page-manipulation-page-layout-cover-line.svg": 52411,
	"./icon-header-page-manipulation-page-layout-double-page-line.svg": 81375,
	"./icon-header-page-manipulation-page-layout-single-page-line.svg": 53232,
	"./icon-header-page-manipulation-page-rotation-clockwise-line.svg": 82594,
	"./icon-header-page-manipulation-page-rotation-counterclockwise-line.svg": 90648,
	"./icon-header-page-manipulation-page-transition-continuous-page-line.svg": 14456,
	"./icon-header-page-manipulation-page-transition-page-by-page-line.svg": 23284,
	"./icon-header-page-manipulation-page-transition-reader.svg": 80023,
	"./icon-header-pan.svg": 64629,
	"./icon-header-print-line.svg": 69124,
	"./icon-header-search.svg": 43884,
	"./icon-header-select-line.svg": 67783,
	"./icon-header-settings-line.svg": 72710,
	"./icon-header-sidebar-line.svg": 11819,
	"./icon-header-zoom-fit-to-page.svg": 17225,
	"./icon-header-zoom-fit-to-width.svg": 47052,
	"./icon-header-zoom-in-line.svg": 95302,
	"./icon-header-zoom-marquee.svg": 99310,
	"./icon-header-zoom-out-line.svg": 65993,
	"./icon-image-green.svg": 59593,
	"./icon-index-panel-list.svg": 15026,
	"./icon-info.svg": 74052,
	"./icon-insert-ribbon.svg": 53928,
	"./icon-keyboard.svg": 97023,
	"./icon-light-mode-option.svg": 98426,
	"./icon-linestyle-cloudy-line.svg": 52713,
	"./icon-linestyle-dash-1-4-8-4.svg": 87679,
	"./icon-linestyle-dash-2-2.svg": 24678,
	"./icon-linestyle-dash-3-6-10-6.svg": 1266,
	"./icon-linestyle-dash-4-4.svg": 62338,
	"./icon-linestyle-dash-4-6-10-6.svg": 83807,
	"./icon-linestyle-dash-6-6.svg": 10758,
	"./icon-linestyle-end-arrow-closed-reverse.svg": 66839,
	"./icon-linestyle-end-arrow-closed.svg": 17198,
	"./icon-linestyle-end-arrow-open-reverse.svg": 85971,
	"./icon-linestyle-end-arrow-open.svg": 38978,
	"./icon-linestyle-end-butt.svg": 23165,
	"./icon-linestyle-end-circle.svg": 60502,
	"./icon-linestyle-end-diamond.svg": 22238,
	"./icon-linestyle-end-slash.svg": 48773,
	"./icon-linestyle-end-square.svg": 36395,
	"./icon-linestyle-none.svg": 30324,
	"./icon-linestyle-solid-line.svg": 99154,
	"./icon-linestyle-start-arrow-closed-reverse.svg": 6274,
	"./icon-linestyle-start-arrow-closed.svg": 26871,
	"./icon-linestyle-start-arrow-open-reverse.svg": 71438,
	"./icon-linestyle-start-arrow-open.svg": 2619,
	"./icon-linestyle-start-butt.svg": 72260,
	"./icon-linestyle-start-circle.svg": 39287,
	"./icon-linestyle-start-diamond.svg": 26137,
	"./icon-linestyle-start-slash.svg": 51946,
	"./icon-linestyle-start-square.svg": 59718,
	"./icon-lock-wire.svg": 47025,
	"./icon-lock.svg": 98557,
	"./icon-magnifying-glass.svg": 82604,
	"./icon-menu-add.svg": 2367,
	"./icon-menu-align-centre.svg": 48751,
	"./icon-menu-align-left.svg": 62713,
	"./icon-menu-align-right.svg": 39812,
	"./icon-menu-bold.svg": 44443,
	"./icon-menu-both-align.svg": 99511,
	"./icon-menu-center-align.svg": 76561,
	"./icon-menu-checkmark.svg": 97717,
	"./icon-menu-italic.svg": 59382,
	"./icon-menu-left-align.svg": 26729,
	"./icon-menu-right-align.svg": 67464,
	"./icon-menu-style-line.svg": 64880,
	"./icon-menu-text-underline.svg": 93940,
	"./icon-no-marked-redactions.svg": 63809,
	"./icon-office-editor-bullet-list.svg": 37948,
	"./icon-office-editor-circle.svg": 66459,
	"./icon-office-editor-line-spacing.svg": 2361,
	"./icon-office-editor-list-style-arrow.svg": 62511,
	"./icon-office-editor-list-style-bullet.svg": 49548,
	"./icon-office-editor-list-style-check.svg": 43452,
	"./icon-office-editor-list-style-diamond.svg": 17888,
	"./icon-office-editor-list-style-latin-roman.svg": 89642,
	"./icon-office-editor-list-style-number-decimal.svg": 92237,
	"./icon-office-editor-list-style-number-latin-1.svg": 16284,
	"./icon-office-editor-list-style-number-latin-2.svg": 95311,
	"./icon-office-editor-list-style-roman-latin.svg": 59274,
	"./icon-office-editor-list-style-square-bullet.svg": 67506,
	"./icon-office-editor-list-style-square.svg": 50257,
	"./icon-office-editor-number-list.svg": 57445,
	"./icon-office-editor-page-break.svg": 13116,
	"./icon-office-editor-toggle-non-printing-characters.svg": 19622,
	"./icon-open-folder.svg": 9153,
	"./icon-operation-eraser.svg": 85012,
	"./icon-operation-redo.svg": 42004,
	"./icon-operation-undo.svg": 5134,
	"./icon-page-controls.svg": 44852,
	"./icon-page-insertion-insert.svg": 68589,
	"./icon-page-manipulation-extract.svg": 72985,
	"./icon-page-move-down.svg": 35522,
	"./icon-page-move-left.svg": 51401,
	"./icon-page-move-right.svg": 11156,
	"./icon-page-move-up.svg": 52657,
	"./icon-page-replacement.svg": 36482,
	"./icon-panel-outlines.svg": 30722,
	"./icon-panel-thumbnail-line.svg": 67208,
	"./icon-paste-without-formatting.svg": 12682,
	"./icon-paste.svg": 47889,
	"./icon-pdf-portfolio.svg": 20277,
	"./icon-pencil-line.svg": 86214,
	"./icon-plus-sign.svg": 60214,
	"./icon-portfolio-file.svg": 91675,
	"./icon-portfolio-folder.svg": 31865,
	"./icon-post-reply.svg": 27725,
	"./icon-redact-panel.svg": 78810,
	"./icon-save.svg": 15503,
	"./icon-signature-plus-disabled.svg": 10376,
	"./icon-signature-plus-sign.svg": 90507,
	"./icon-style-panel-toggle.svg": 13331,
	"./icon-sync.svg": 13425,
	"./icon-text-bold.svg": 95643,
	"./icon-text-italic.svg": 16726,
	"./icon-text-justify-center.svg": 55408,
	"./icon-text-underline.svg": 57302,
	"./icon-thumbtack.svg": 33191,
	"./icon-tool-arc.svg": 72257,
	"./icon-tool-callout-line.svg": 57520,
	"./icon-tool-changeview.svg": 18888,
	"./icon-tool-check-stamp.svg": 93343,
	"./icon-tool-comment-line.svg": 97481,
	"./icon-tool-cross-stamp.svg": 42811,
	"./icon-tool-dot-stamp.svg": 15162,
	"./icon-tool-fill-and-sign-calendar.svg": 56389,
	"./icon-tool-highlight.svg": 15453,
	"./icon-tool-image-line.svg": 84477,
	"./icon-tool-link.svg": 67643,
	"./icon-tool-measurement-arc.svg": 85234,
	"./icon-tool-measurement-area-ellipse-line.svg": 24227,
	"./icon-tool-measurement-area-line.svg": 19636,
	"./icon-tool-measurement-area-polygon-line.svg": 13919,
	"./icon-tool-measurement-cloud-area-line.svg": 63104,
	"./icon-tool-measurement-distance-line.svg": 99082,
	"./icon-tool-measurement-perimeter.svg": 93379,
	"./icon-tool-model3d.svg": 83727,
	"./icon-tool-more.svg": 63256,
	"./icon-tool-page-redact.svg": 15524,
	"./icon-tool-pen-highlight.svg": 32023,
	"./icon-tool-pen-line.svg": 47223,
	"./icon-tool-redaction-area.svg": 18984,
	"./icon-tool-select-area-redaction.svg": 33371,
	"./icon-tool-select-pages.svg": 88448,
	"./icon-tool-shape-arrow.svg": 3886,
	"./icon-tool-shape-cloud.svg": 90726,
	"./icon-tool-shape-line.svg": 46417,
	"./icon-tool-shape-oval.svg": 32571,
	"./icon-tool-shape-polygon.svg": 2887,
	"./icon-tool-shape-polyline.svg": 30011,
	"./icon-tool-shape-rectangle.svg": 21942,
	"./icon-tool-signature.svg": 41615,
	"./icon-tool-stamp-line.svg": 30083,
	"./icon-tool-text-free-text.svg": 24991,
	"./icon-tool-text-manipulation-highlight.svg": 84935,
	"./icon-tool-text-manipulation-squiggly.svg": 41196,
	"./icon-tool-text-manipulation-strikethrough.svg": 44774,
	"./icon-tool-text-manipulation-underline.svg": 1771,
	"./icon-tool-unlink.svg": 5046,
	"./icon-tools-more-active.svg": 53196,
	"./icon-tools-more-vertical.svg": 8211,
	"./icon-tools-more.svg": 96561,
	"./icon-unposted-comment.svg": 9292,
	"./icon-view-ribbon.svg": 58084,
	"./icon-view.svg": 7379,
	"./icon-watermark-panel.svg": 84775,
	"./icon-zoom-thumb-in.svg": 64058,
	"./icon-zoom-thumb-out.svg": 82989,
	"./illustration - empty state - outlines.svg": 4711,
	"./multi select.svg": 72753,
	"./redact-icons-credit-card.svg": 45919,
	"./redact-icons-email.svg": 27437,
	"./redact-icons-image.svg": 90814,
	"./redact-icons-phone-number.svg": 2761,
	"./style-panel-no-tool-selected.svg": 95685,
	"./textselect_cursor.svg": 30370,
	"./ungroup-annotations-icon.svg": 52595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35450;